import * as Type from './types'

export function showLoader(message='LOADING') {
    return {
        type: Type.SHOW_LOADER,
        data: {
            message: message,
            display: true
        }
    }
}

export function hideLoader() {
    return {
        type: Type.HIDE_LOADER,
        data: {
            message: '',
            display: false
        }
    }
}

export function showDrawer() {
    return {
        type: Type.SHOW_DRAWER,
        data: { display: true }
    }
}

export function hideDrawer() {
    return {
        type: Type.HIDE_DRAWER,
        data: { display: false }
    }
}

export function hideLeftPanel() {
    return {
        type: Type.HIDE_LEFTPANEL,
        data: true
    }
}

export function showLeftPanel() {
    return {
        type: Type.SHOW_LEFTPANEL,
        data: false
    }
}

export function showSnackbar(message, mode = 'info', duration = 5000, position={vertical: 'top', horizontal: 'right' }) {
    return {
        type: Type.SHOW_SNACKBAR,
        data: {
            message: message,
            mode: mode,
            autoHideDuration: duration,
            position: position,
            open: true
        }
    }
}

export function hideSnackbar() {
    return {
        type: Type.HIDE_SNACKBAR,
        data: {
            message: '',
            open: false
        }
    }
}

export function stackSnackbar(data) {
    return {
        type: Type.STACK_SNACKBAR,
        data: data
    }
}

export function setLoader(section, loader, value = 0) {
    return {
        type: Type.SET_LOADER,
        data: {
            section: section,
            loader: loader,
            value: value
        }
    }
}

export function setLoaders(section, value) {
    return {
        type: Type.SET_LOADERS,
        data: {
            section: section,
            value: value
        }
    }
}
